import { render, staticRenderFns } from "./DataQuerySummary.vue?vue&type=template&id=76782a67&"
import script from "./DataQuerySummary.vue?vue&type=script&lang=ts&"
export * from "./DataQuerySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports